export default "__VITE_ASSET__BOhhWJ$h__"